// extracted by mini-css-extract-plugin
export var chevronIcon = "_a7-2";
export var teamName = "_a7-1";
export var teamSwitcherButton = "_a7-0";